import request from '@/utils/request';
// 评论审核

// 审核列表
export function commentList(data) {
	return request({
		url: '/management/audit/comment/list',
		method: 'get',
		params: data
	})
}

// 审核
export function conmentUpdate(data) {
	return request({
		url: '/management/audit/comment/update',
		method: 'post',
		data: data
	})
}

// 审核人
export function auditorList(data) {
	return request({
		url: '/management/audit/comment/auditor/list',
		method: 'post',
		data: data
	})
}

// 删除评论
export function deleteComment(params) {
	return request({
		url: '/comment/delete',
		method: 'get',
		params: params
	})
}